module.exports = __webpack_public_path__ + "static/media/pencil.6f1c2e8e.svg";